"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5881],{

/***/ 47119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17845);
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE





var wrapper = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .display */ .jfB("flex"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .justifyContent */ .KlP("center"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .alignContent */ .Kvj("center"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .background */ .Oq0({
        NAME: "linearGradient",
        VAL: [
            {
                NAME: "deg",
                VAL: 180
            },
            [
                [
                    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .pct */ .hdZ(50),
                    _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .white */ .ix
                ],
                [
                    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .pct */ .hdZ(0),
                    _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .Business.stone */ .e.stone
                ]
            ]
        ]
    }),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .paddingTop */ .odA(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hOB(2)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .paddingBottom */ .EtG(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hOB(2))
]);
var container = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .backgroundColor */ .Czw(_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .Business.darkPurple */ .e.darkPurple),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .padding */ .o3D(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hOB(2)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .display */ .jfB("flex"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .borderRadius */ .E0l(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(4)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .desktop */ .gv, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .width */ .bf$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .pct */ .hdZ(80)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .flexDirection */ .Me8("row")
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .tabletOrMobile */ .k$, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .width */ .bf$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .pct */ .hdZ(90)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .flexDirection */ .Me8("column")
    ])
]);
var Styles = {
    wrapper: wrapper,
    container: container
};
function AutomateSimplify(props) {
    var classname = props.classname;
    var classname$1 = classname !== undefined ? classname : "";
    var wrapper$1 = classnames__WEBPACK_IMPORTED_MODULE_0___default()([
        wrapper,
        classname$1
    ]);
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
            children: props.children,
            className: container
        }),
        className: wrapper$1
    });
}
var make = AutomateSimplify;
 /* wrapper Not a pure module */ 


/***/ }),

/***/ 94702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17845);
/* harmony import */ var _theme_Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1476);
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE






var description = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _theme_Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .SofiaPro.family */ .t.family,
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginBottom */ .yl7(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hOB(0.75)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(16)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(24)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_Y(_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .white */ .ix),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .largeScreen */ .M6, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginBottom */ .yl7(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hOB(1.5))
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .belowLargeScreen */ .Qo, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginBottom */ .yl7(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hOB(1))
    ])
]);
var Styles = {
    description: description
};
function AutomateSimplify__BodyText(props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: props.children,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
            description,
            className$1
        ])
    });
}
var make = AutomateSimplify__BodyText;
 /* description Not a pure module */ 


/***/ }),

/***/ 49611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE




var wrapper = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .display */ .jfB("flex"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .flexDirection */ .Me8("column"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .width */ .bf$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .pct */ .hdZ(50)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .justifyContent */ .KlP("center"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .alignItems */ .cq$("flexEnd"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .tabletOrMobile */ .k$, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginTop */ .E9m(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hOB(1)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .justifyContent */ .KlP("center"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .alignItems */ .cq$("flexStart")
    ])
]);
var Styles = {
    wrapper: wrapper
};
function AutomateSimplify__CTAContainer(props) {
    var classname = props.classname;
    var classname$1 = classname !== undefined ? classname : "";
    var wrapper$1 = classnames__WEBPACK_IMPORTED_MODULE_0___default()([
        wrapper,
        classname$1
    ]);
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: props.children,
        className: wrapper$1
    });
}
var make = AutomateSimplify__CTAContainer;
 /* wrapper Not a pure module */ 


/***/ }),

/***/ 4412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17845);
/* harmony import */ var _theme_Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1476);
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70965);
/* harmony import */ var _theme_Theme_Typography_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32567);
// Generated by ReScript, PLEASE EDIT WITH CARE







var heading = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginBottom */ .yl7(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hOB(0.75)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .width */ .bf$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .pct */ .hdZ(100)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .largeScreen */ .M6, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginBottom */ .yl7(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hOB(1.5))
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .selector */ .nZE("h1, h2, h3, h4, h5, h6", [
        _theme_Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .SofiaPro.family */ .t.family,
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_Y(_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .white */ .ix),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .margin */ .e6$("zero"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight */ .Ue2("semiBold"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .desktop */ .gv, [
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(32)),
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(48))
        ]),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .tabletOrMobile */ .k$, _theme_Theme_Typography_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .Styles.style3_ */ .z.style3_)
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .selector */ .nZE("strong", [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_Y(_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .Common.tangerine */ .Gn.tangerine)
    ])
]);
var Styles = {
    heading: heading
};
function AutomateSimplify__Heading(props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: props.children,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
            heading,
            className$1
        ])
    });
}
var make = AutomateSimplify__Heading;
 /* heading Not a pure module */ 


/***/ }),

/***/ 59253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36585);
// Generated by ReScript, PLEASE EDIT WITH CARE


var wrapper = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .display */ .jfB("flex"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flexDirection */ .Me8("column")
]);
var Styles = {
    wrapper: wrapper
};
function AutomateSimplify__TextContainer(props) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("div", {
        children: props.children,
        className: wrapper
    });
}
var make = AutomateSimplify__TextContainer;
 /* wrapper Not a pure module */ 


/***/ }),

/***/ 63865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ FeatureBlock_gen_make; }
});

// NAMESPACE OBJECT: ./node_modules/@prezzee/ribbon/src/components/business/FeatureBlock/FeatureBlock.bs.js
var FeatureBlock_bs_namespaceObject = {};
__webpack_require__.r(FeatureBlock_bs_namespaceObject);
__webpack_require__.d(FeatureBlock_bs_namespaceObject, {
  "CardContainer": function() { return CardContainer; },
  "Description": function() { return Description; },
  "Styles": function() { return Styles; },
  "Title": function() { return Title; },
  "make": function() { return make; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/bindings/BsCss/BsCssJs.bs.js + 1 modules
var BsCssJs_bs = __webpack_require__(36585);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Color.bs.js
var Theme_Color_bs = __webpack_require__(17845);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Responsive.bs.js
var Theme_Responsive_bs = __webpack_require__(70965);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/business/FeatureBlock/FeatureBlock.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





var wrapper = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* display */.jfB("flex"),
    BsCssJs_bs/* flexDirection */.Me8("column"),
    BsCssJs_bs/* justifyContent */.KlP("center"),
    BsCssJs_bs/* alignItems */.cq$("center"),
    BsCssJs_bs/* backgroundColor */.Czw(Theme_Color_bs/* Business.prezzeePurple */.e.prezzeePurple)
]);
var container = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* width */.bf$(BsCssJs_bs/* pct */.hdZ(80)),
    BsCssJs_bs/* paddingTop */.odA(BsCssJs_bs/* rem */.hOB(2)),
    BsCssJs_bs/* paddingBottom */.EtG(BsCssJs_bs/* rem */.hOB(2)),
    BsCssJs_bs/* media */.BC2(Theme_Responsive_bs/* smallScreenOrMobile */.HH, [
        BsCssJs_bs/* width */.bf$(BsCssJs_bs/* pct */.hdZ(90))
    ])
]);
var Styles = {
    wrapper: wrapper,
    container: container
};
function FeatureBlock(props) {
    var classname = props.classname;
    var classname$1 = classname !== undefined ? classname : "";
    var wrapper$1 = classnames_default()([
        wrapper,
        classname$1
    ]);
    return jsx_runtime.jsx("div", {
        children: jsx_runtime.jsx("div", {
            children: props.children,
            className: container
        }),
        className: wrapper$1
    });
}
var Title;
var Description;
var CardContainer;
var make = FeatureBlock;
 /* wrapper Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/business/FeatureBlock/FeatureBlock.gen.tsx
/* TypeScript file generated from FeatureBlock.res by genType. */ /* eslint-disable import/first */ // @ts-ignore: Implicit any on import

var FeatureBlockBS = FeatureBlock_bs_namespaceObject;
var FeatureBlock_gen_make = FeatureBlockBS.make;


/***/ }),

/***/ 61326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ FeatureBlock_CardContainer_gen_make; }
});

// NAMESPACE OBJECT: ./node_modules/@prezzee/ribbon/src/components/business/FeatureBlock/FeatureBlock__CardContainer.bs.js
var FeatureBlock_CardContainer_bs_namespaceObject = {};
__webpack_require__.r(FeatureBlock_CardContainer_bs_namespaceObject);
__webpack_require__.d(FeatureBlock_CardContainer_bs_namespaceObject, {
  "Styles": function() { return Styles; },
  "make": function() { return make; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/bindings/BsCss/BsCssJs.bs.js + 1 modules
var BsCssJs_bs = __webpack_require__(36585);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/business/FeatureBlock/FeatureBlock__CardContainer.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



var cardContainer = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* marginBottom */.yl7(BsCssJs_bs/* rem */.hOB(4))
]);
var Styles = {
    cardContainer: cardContainer
};
function FeatureBlock__CardContainer(props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    return jsx_runtime.jsx("div", {
        children: props.children,
        className: classnames_default()([
            cardContainer,
            className$1
        ])
    });
}
var make = FeatureBlock__CardContainer;
 /* cardContainer Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/business/FeatureBlock/FeatureBlock__CardContainer.gen.tsx
/* TypeScript file generated from FeatureBlock__CardContainer.res by genType. */ /* eslint-disable import/first */ // @ts-ignore: Implicit any on import

var FeatureBlock__CardContainerBS = FeatureBlock_CardContainer_bs_namespaceObject;
var FeatureBlock_CardContainer_gen_make = FeatureBlock__CardContainerBS.make;


/***/ }),

/***/ 40863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE




var wrapper = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .display */ .jfB("flex"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .padding2 */ .BLt(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(40), _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(30)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .paddingRight */ .WLm(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .zero */ .bMI),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .tablet */ .Mq, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .padding2 */ .BLt(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(30), _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(15)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .paddingRight */ .WLm(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .zero */ .bMI)
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .smallScreenOrMobile */ .HH, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .padding4 */ ._fG(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(20), _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .zero */ .bMI, _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .zero */ .bMI, _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .zero */ .bMI),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .flexDirection */ .Me8("column")
    ])
]);
var Styles = {
    wrapper: wrapper
};
function InnovativeWayToGift(props) {
    var classname = props.classname;
    var classname$1 = classname !== undefined ? classname : "";
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: props.children,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
            wrapper,
            classname$1
        ])
    });
}
var make = InnovativeWayToGift;
 /* wrapper Not a pure module */ 


/***/ }),

/***/ 37585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE




var container = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .selector */ .nZE("img", [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .display */ .jfB("block"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .width */ .bf$("auto"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .height */ .Cb8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .pct */ .hdZ(100)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .maxWidth */ .kkr(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .pct */ .hdZ(100)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .maxHeight */ .kCL(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(470)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .objectFit */ .fXf("contain"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .position */ .FKU("relative"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .zIndex */ .W5D(1),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .smallScreenOrMobile */ .HH, [
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .height */ .Cb8("auto"),
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .maxHeight */ .kCL("none")
        ])
    ])
]);
var Styles = {
    container: container
};
function InnovativeWayToGift__BackgroundImage(props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: props.children,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
            container,
            className$1
        ])
    });
}
var make = InnovativeWayToGift__BackgroundImage;
 /* container Not a pure module */ 


/***/ }),

/***/ 73289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17845);
/* harmony import */ var _theme_Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1476);
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE






var description = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _theme_Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .SofiaPro.family */ .t.family,
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginBottom */ .yl7(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hOB(0.75)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(24)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_Y(_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .Business.bodyTextGrey */ .e.bodyTextGrey),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .largeScreen */ .M6, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginBottom */ .yl7(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hOB(1.5))
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .belowLargeScreen */ .Qo, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginBottom */ .yl7(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hOB(1))
    ])
]);
var Styles = {
    description: description
};
function InnovativeWayToGift__BodyText(props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: props.children,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
            description,
            className$1
        ])
    });
}
var make = InnovativeWayToGift__BodyText;
 /* description Not a pure module */ 


/***/ }),

/***/ 98151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE



var ctaLine = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .display */ .jfB("inlineFlex"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flexWrap */ .WOS("wrap"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flexBasis */ .P_T(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginLeft */ .oIA(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(-12)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginTop */ .E9m(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(-12)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .smallScreenOrMobile */ .HH, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(80))
    ])
]);
var Styles = {
    ctaLine: ctaLine
};
function InnovativeWayToGift__CTA(props) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("div", {
        children: props.children,
        className: ctaLine
    });
}
var make = InnovativeWayToGift__CTA;
 /* ctaLine Not a pure module */ 


/***/ }),

/***/ 70360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var _rescript_std_lib_es6_js_array_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32867);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17845);
/* harmony import */ var _theme_Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1476);
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70965);
/* harmony import */ var _theme_Theme_Typography_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32567);
// Generated by ReScript, PLEASE EDIT WITH CARE








var heading = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginBottom */ .yl7(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hOB(0.75)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_Y(_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .Business.charcoal */ .e.charcoal),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .largeScreen */ .M6, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .maxWidth */ .kkr(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(512)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginBottom */ .yl7(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hOB(1.5))
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .selector */ .nZE("h1, h2, h3, h4, h5, h6", [
        _theme_Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .SofiaPro.family */ .t.family,
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .margin */ .e6$("zero"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .largeScreen */ .M6, [
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(50)),
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(63))
        ]),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .belowLargeScreen */ .Qo, _rescript_std_lib_es6_js_array_js__WEBPACK_IMPORTED_MODULE_7__/* .concat */ .zo(_theme_Theme_Typography_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .Styles.style2_ */ .z.style2_, [
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .width */ .bf$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hOB(13))
        ])),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .smallScreenOrMobile */ .HH, [
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .width */ .bf$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hOB(15)),
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginBottom */ .yl7(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hOB(1))
        ])
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .selector */ .nZE("strong", [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_Y(_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .Business.prezzeePurple */ .e.prezzeePurple)
    ])
]);
var Styles = {
    heading: heading
};
function InnovativeWayToGift__Heading(props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: props.children,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
            heading,
            className$1
        ])
    });
}
var make = InnovativeWayToGift__Heading;
 /* heading Not a pure module */ 


/***/ }),

/***/ 17462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE



var container = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .display */ .jfB("flex"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(45)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .alignItems */ .cq$("center"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .justifyContent */ .KlP("center"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .smallScreenOrMobile */ .HH, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100))
    ])
]);
var Styles = {
    container: container
};
function InnovativeWayToGift__ImageContainer(props) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("div", {
        children: props.children,
        className: container
    });
}
var make = InnovativeWayToGift__ImageContainer;
 /* container Not a pure module */ 


/***/ }),

/***/ 12053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE



var container = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .display */ .jfB("flex"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .justifyContent */ .KlP("center"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .alignItems */ .cq$("center"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flexDirection */ .Me8("column"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(55)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .smallScreenOrMobile */ .HH, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100))
    ])
]);
var wrapper = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(85)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .largeScreen */ .M6, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(60))
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .smallScreenOrMobile */ .HH, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginBottom */ .yl7(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hOB(2))
    ])
]);
var Styles = {
    container: container,
    wrapper: wrapper
};
function InnovativeWayToGift__TextContainer(props) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("div", {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("div", {
            children: props.children,
            className: wrapper
        }),
        className: container
    });
}
var make = InnovativeWayToGift__TextContainer;
 /* container Not a pure module */ 


/***/ }),

/***/ 50103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var _common_SectionHeading_SectionHeading_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12387);
/* harmony import */ var _SectionHeading_Theme_Business_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85795);
// Generated by ReScript, PLEASE EDIT WITH CARE


var include = _common_SectionHeading_SectionHeading_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .w(_SectionHeading_Theme_Business_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Theme */ .Q);
var Styles = include.Styles;
var make = include.make;
 /* include Not a pure module */ 


/***/ }),

/***/ 92626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports Heading, List, ListItem, ImageContainer, TextContainer, CTA, Style */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1476);
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE





var wrapper = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _theme_Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .SofiaPro.family */ .t.family,
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .children */ .pIy([
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .flex */ .fUN("auto")
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .tabletSmUp */ .Uv, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .display */ .jfB("flex"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .alignItems */ .cq$("center")
    ])
]);
var Style = {
    wrapper: wrapper
};
function TheGiftExperience(props) {
    var classname = props.classname;
    var classname$1 = classname !== undefined ? classname : "";
    var wrapper$1 = classnames__WEBPACK_IMPORTED_MODULE_0___default()([
        wrapper,
        classname$1
    ]);
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: props.children,
        className: wrapper$1
    });
}
var Heading;
var List;
var ListItem;
var ImageContainer;
var TextContainer;
var CTA;
var make = TheGiftExperience;
 /* wrapper Not a pure module */ 


/***/ }),

/***/ 71066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE




var ctaLine = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginTop */ .E9m(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(28)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .selector */ .nZE("button", [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .width */ .bf$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .pct */ .hdZ(100)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .important */ .efO(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .paddingLeft */ .rv2(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.em(1))),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .important */ .efO(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .paddingRight */ .WLm(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.em(1)))
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .children */ .pIy([
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginBottom */ .yl7(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(16)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .width */ .bf$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(223))
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .desktop */ .gv, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .display */ .jfB("flex"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .flexWrap */ .WOS("wrap"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginTop */ .E9m(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(22)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .children */ .pIy([
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginRight */ .wzR(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(12)),
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .width */ .bf$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(195))
        ]),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .lastChild */ .QOo([
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginRight */ .wzR("zero")
        ])
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .mobile */ .ai, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .children */ .pIy([
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginBottom */ .yl7(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(12))
        ]),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .lastChild */ .QOo([
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginBottom */ .yl7("zero")
        ])
    ])
]);
var Styles = {
    ctaLine: ctaLine
};
function TheGiftExperience__CTA(props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: props.children,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
            ctaLine,
            className$1
        ])
    });
}
var make = TheGiftExperience__CTA;
 /* ctaLine Not a pure module */ 


/***/ }),

/***/ 91265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Style */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17845);
/* harmony import */ var _theme_Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1476);
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE





var heading = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .selector */ .nZE("h2, h3, h4, h5, h6", [
        _theme_Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .SofiaPro.family */ .t.family,
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginTop */ .E9m(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hOB(1)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginBottom */ .yl7(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hOB(1)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(32)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(34)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_Y(_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Business.charcoal */ .e.charcoal),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue2("semiBold"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .tabletSmUp */ .Uv, [
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(32)),
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(40))
        ]),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .desktop */ .gv, [
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(40)),
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(50))
        ])
    ])
]);
var Style = {
    heading: heading
};
function TheGiftExperience__Heading(props) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("div", {
        children: props.children,
        className: heading
    });
}
var make = TheGiftExperience__Heading;
 /* heading Not a pure module */ 


/***/ }),

/***/ 21999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Style */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE



var imageContainer = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .boxSizing */ .ixg("borderBox"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .justifyContent */ .KlP("center"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .tabletSmUp */ .Uv, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .display */ .jfB("flex"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .justifyContent */ .KlP("flexEnd"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginTop */ .E9m(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hOB(2)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginBottom */ .yl7(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hOB(2))
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .tabletOrDesktop */ .ab, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flexGrow */ .H78(0),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flexShrink */ .i4v(0),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flexBasis */ .P_T(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(50))
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .desktop */ .gv, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flexGrow */ .H78(1),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flexShrink */ .i4v(1),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flexBasis */ .P_T("auto"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .justifyContent */ .KlP("center")
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .tabletSm */ .FV, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginTop */ .E9m(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(31))
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .selector */ .nZE("img", [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .display */ .jfB("block"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .maxWidth */ .kkr(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(544)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .height */ .Cb8("auto"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginLeft */ .oIA("auto"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginRight */ .wzR("auto"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginBottom */ .yl7("auto")
    ])
]);
var Style = {
    imageContainer: imageContainer
};
function TheGiftExperience__ImageContainer(props) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("div", {
        children: props.children,
        className: imageContainer
    });
}
var make = TheGiftExperience__ImageContainer;
 /* imageContainer Not a pure module */ 


/***/ }),

/***/ 75761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports ListItem, Style */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36585);
// Generated by ReScript, PLEASE EDIT WITH CARE


var uniqueSellingPointsList = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .children */ .pIy([
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .lastChild */ .QOo([
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginBottom */ .yl7(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .zero */ .bMI)
        ])
    ])
]);
var Style = {
    uniqueSellingPointsList: uniqueSellingPointsList
};
function TheGiftExperience__List(props) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("div", {
        children: props.children,
        className: uniqueSellingPointsList
    });
}
var ListItem;
var make = TheGiftExperience__List;
 /* uniqueSellingPointsList Not a pure module */ 


/***/ }),

/***/ 89586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports ListItemIcon, Styles */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17845);
// Generated by ReScript, PLEASE EDIT WITH CARE



var wrapper = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .display */ .jfB("flex"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .alignItems */ .cq$("center"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_Y(_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Business.bodyTextGrey */ .e.bodyTextGrey),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue2("medium")
]);
var Styles = {
    wrapper: wrapper
};
function TheGiftExperience__ListItem(props) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("div", {
        children: props.children,
        className: wrapper
    });
}
var ListItemIcon;
var make = TheGiftExperience__ListItem;
 /* wrapper Not a pure module */ 


/***/ }),

/***/ 77715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17845);
// Generated by ReScript, PLEASE EDIT WITH CARE



var icon = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flexBasis */ .P_T(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(45)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flexGrow */ .H78(0),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flexShrink */ .i4v(0),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .height */ .Cb8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(45)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .display */ .jfB("flex"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .alignItems */ .cq$("center"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .justifyContent */ .KlP("center"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .borderRadius */ .E0l(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(8)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginRight */ .wzR(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(16)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(24)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_Y(_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Business.prezzeePurple */ .e.prezzeePurple),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .backgroundColor */ .Czw(_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Business.stone */ .e.stone),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .children */ .pIy([
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .maxWidth */ .kkr(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.em(1)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .maxHeight */ .kCL(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.em(1)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .display */ .jfB("inlineBlock"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$("auto"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .height */ .Cb8("auto")
    ])
]);
var Styles = {
    icon: icon
};
function TheGiftExperience__ListItemIcon(props) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("div", {
        children: props.children,
        className: icon
    });
}
var make = TheGiftExperience__ListItemIcon;
 /* icon Not a pure module */ 


/***/ }),

/***/ 240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1476);
// Generated by ReScript, PLEASE EDIT WITH CARE



var text = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv([
    _theme_Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .SofiaPro.family */ .t.family,
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flexBasis */ .P_T("auto"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flexGrow */ .H78(1),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flexShrink */ .i4v(1)
]);
var Styles = {
    text: text
};
function TheGiftExperience__ListItemText(props) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("div", {
        children: props.children,
        className: text
    });
}
var make = TheGiftExperience__ListItemText;
 /* text Not a pure module */ 


/***/ }),

/***/ 14556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Style */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17845);
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE




var textContainer = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_Y(_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Personal.midGrey */ .RL.midGrey),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .boxSizing */ .ixg("borderBox"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .display */ .jfB("flex"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flexDirection */ .Me8("column"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .tabletSmUp */ .Uv, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flexGrow */ .H78(1),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flexShrink */ .i4v(1),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .paddingRight */ .WLm(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(20))
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .desktop */ .gv, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .paddingBottom */ .EtG(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(50)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flexBasis */ .P_T(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(630)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .justifyContent */ .KlP("center")
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .tabletOrMobile */ .k$, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flexBasis */ .P_T(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(50))
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .tabletSm */ .FV, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .maxWidth */ .kkr("none")
    ])
]);
var Style = {
    textContainer: textContainer
};
function TheGiftExperience__TextContainer(props) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("div", {
        children: props.children,
        className: textContainer
    });
}
var make = TheGiftExperience__TextContainer;
 /* textContainer Not a pure module */ 


/***/ }),

/***/ 41690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
// Generated by ReScript, PLEASE EDIT WITH CARE



var background = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .position */ .FKU("absolute"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .zIndex */ .W5D(0),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .left */ .t$v("zero"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .top */ .wey("zero"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .width */ .bf$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .pct */ .hdZ(100)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .height */ .Cb8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .pct */ .hdZ(100)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .selector */ .nZE(".fresnel-container", [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .position */ .FKU("absolute"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .left */ .t$v("zero"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .top */ .wey("zero"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .width */ .bf$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .pct */ .hdZ(100)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .height */ .Cb8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .pct */ .hdZ(100))
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .selector */ .nZE("img", [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .display */ .jfB("block"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .width */ .bf$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .pct */ .hdZ(100)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .height */ .Cb8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .pct */ .hdZ(100)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .objectFit */ .fXf("cover"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .objectPosition */ .YP6("top")
    ])
]);
var Styles = {
    background: background
};
function FullWidthCarousel__SlideBackground(props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: props.children,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
            background,
            className$1
        ])
    });
}
var make = FullWidthCarousel__SlideBackground;
 /* background Not a pure module */ 


/***/ }),

/***/ 73917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
/* harmony import */ var _personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78078);
/* harmony import */ var _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17845);
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE






var container = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_Y(_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .Business.bodyTextGrey */ .e.bodyTextGrey),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(16)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(32)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .desktop */ .gv, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(18))
    ])
]);
var content = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .selector */ .nZE("& > :first-child", [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginTop */ .E9m("zero")
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .selector */ .nZE("& > :last-child", [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginBottom */ .yl7("zero")
    ])
]);
var Styles = {
    container: container,
    content: content
};
function FullWidthCarousel__SlideDescription(props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_3__.make, {
            children: props.children,
            className: content
        }),
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
            container,
            className$1
        ])
    });
}
var make = FullWidthCarousel__SlideDescription;
 /* container Not a pure module */ 


/***/ }),

/***/ 10673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17845);
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE





var footerText = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_Y(_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .Business.charcoal */ .e.charcoal),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(14)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.em(1.1)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginTop */ .E9m(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(12)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight */ .Ue2("semiBold"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .desktop */ .gv, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(16))
    ])
]);
var Styles = {
    footerText: footerText
};
function FullWidthCarousel__SlideFooterText(props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: props.children,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
            footerText,
            className$1
        ])
    });
}
var make = FullWidthCarousel__SlideFooterText;
 /* footerText Not a pure module */ 


/***/ }),

/***/ 97613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE




var icon = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginBottom */ .yl7(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(20)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .tabletSm */ .FV, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginBottom */ .yl7(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(12))
    ])
]);
var Styles = {
    icon: icon
};
function FullWidthCarousel__SlideIcon(props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: props.children,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
            icon,
            className$1
        ])
    });
}
var make = FullWidthCarousel__SlideIcon;
 /* icon Not a pure module */ 


/***/ }),

/***/ 77428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports Styles, StyleGen */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE




var grid = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .display */ .jfB("grid"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .gridTemplateRows */ .RGf([
        "auto"
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .flexWrap */ .WOS("wrap"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .justifyContent */ .KlP("center"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .justifyItems */ .eYb("center"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .alignItems */ .cq$("center"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .selector */ .nZE("img", [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .maxWidth */ .kkr(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .pct */ .hdZ(100)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .maxHeight */ .kCL(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .pct */ .hdZ(100)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .height */ .Cb8("auto")
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .selector */ .nZE("&>*", [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .display */ .jfB("flex"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .alignItems */ .cq$("center"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .justifyContent */ .KlP("center")
    ])
]);
var Styles = {
    grid: grid
};
function perRow(pr) {
    return _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .desktop */ .gv, [
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .gridTemplateColumns */ .K$K([
                {
                    NAME: "repeat",
                    VAL: [
                        {
                            NAME: "num",
                            VAL: pr
                        },
                        "auto"
                    ]
                }
            ])
        ])
    ]);
}
function perRowTablet(pr) {
    return _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .tablet */ .Mq, [
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .gridTemplateColumns */ .K$K([
                {
                    NAME: "repeat",
                    VAL: [
                        {
                            NAME: "num",
                            VAL: pr
                        },
                        "auto"
                    ]
                }
            ])
        ])
    ]);
}
function perRowMobile(pr) {
    return _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .tabletSm */ .FV, [
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .gridTemplateColumns */ .K$K([
                {
                    NAME: "repeat",
                    VAL: [
                        {
                            NAME: "num",
                            VAL: pr
                        },
                        "auto"
                    ]
                }
            ])
        ])
    ]);
}
function gapStyle(gap) {
    return _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .desktop */ .gv, [
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .gridGap */ .Ccm(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(gap))
        ])
    ]);
}
function gapStyleTablet(gap) {
    return _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .tablet */ .Mq, [
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .gridGap */ .Ccm(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(gap))
        ])
    ]);
}
function gapStyleMobile(gap) {
    return _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .tabletSm */ .FV, [
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .gridGap */ .Ccm(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(gap))
        ])
    ]);
}
var StyleGen = {
    perRow: perRow,
    perRowTablet: perRowTablet,
    perRowMobile: perRowMobile,
    gapStyle: gapStyle,
    gapStyleTablet: gapStyleTablet,
    gapStyleMobile: gapStyleMobile
};
function ImageGrid(props) {
    var perRowMobile$1 = props.perRowMobile;
    var perRowTablet$1 = props.perRowTablet;
    var perRow$1 = props.perRow;
    var gapMobile = props.gapMobile;
    var gapTablet = props.gapTablet;
    var gap = props.gap;
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    var gap$1 = gap !== undefined ? gap : 0;
    var gapTablet$1 = gapTablet !== undefined ? gapTablet : 0;
    var gapMobile$1 = gapMobile !== undefined ? gapMobile : 0;
    var perRow$2 = perRow$1 !== undefined ? perRow$1 : 6;
    var perRowTablet$2 = perRowTablet$1 !== undefined ? perRowTablet$1 : 6;
    var perRowMobile$2 = perRowMobile$1 !== undefined ? perRowMobile$1 : 2;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: props.children,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
            grid,
            gapStyle(gap$1),
            gapStyleTablet(gapTablet$1),
            gapStyleMobile(gapMobile$1),
            perRow(perRow$2),
            perRowTablet(perRowTablet$2),
            perRowMobile(perRowMobile$2),
            className$1
        ])
    });
}
var make = ImageGrid;
 /* grid Not a pure module */ 


/***/ }),

/***/ 23462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports Block, Heading, Description, Content, Styles */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE




var container = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .display */ .jfB("grid"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .gridTemplateColumns */ .K$K([
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.fr(1)
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .gridTemplateRows */ .RGf([
        "auto"
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .gridGap */ .Ccm(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(16)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .tabletSmUp */ .Uv, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .gridTemplateColumns */ .K$K([
            {
                NAME: "repeat",
                VAL: [
                    {
                        NAME: "num",
                        VAL: 2
                    },
                    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.fr(1)
                ]
            }
        ]),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .gridGap */ .Ccm(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(28)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .selector */ .nZE("&>*:nth-of-type(odd)", [
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginBottom */ .yl7(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(54))
        ]),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .selector */ .nZE("&>*:nth-of-type(even)", [
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginTop */ .E9m(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(54))
        ])
    ])
]);
var Styles = {
    container: container
};
function OffsetBlocks(props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: props.children,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
            container,
            className$1
        ])
    });
}
var Block;
var Heading;
var Description;
var Content;
var make = OffsetBlocks;
 /* container Not a pure module */ 


/***/ }),

/***/ 96532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17845);
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE





var block = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .backgroundColor */ .Czw(_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .white */ .ix),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .borderRadius */ .E0l(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(10)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .padding3 */ .OqZ(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(16), _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(20), _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(54)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .display */ .jfB("flex"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .flexDirection */ .Me8("column"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .tabletSm */ .FV, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .padding3 */ .OqZ(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(24), _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(24), _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(30))
    ])
]);
var Styles = {
    block: block
};
function OffsetBlocks__Block(props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: props.children,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
            block,
            className$1
        ])
    });
}
var make = OffsetBlocks__Block;
 /* block Not a pure module */ 


/***/ }),

/***/ 42163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
// Generated by ReScript, PLEASE EDIT WITH CARE



var content = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .margin2 */ .h9x("auto", "zero")
]);
var Styles = {
    content: content
};
function OffsetBlocks__BlockContent(props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: props.children,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
            content,
            className$1
        ])
    });
}
var make = OffsetBlocks__BlockContent;
 /* content Not a pure module */ 


/***/ }),

/***/ 53130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17845);
/* harmony import */ var _theme_Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1476);
// Generated by ReScript, PLEASE EDIT WITH CARE





var heading = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .selector */ .nZE("h1, h2, h3, h4, h5, h6", [
        _theme_Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .SofiaPro.family */ .t.family,
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight */ .Ue2("semiBold"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_Y(_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .Business.charcoal */ .e.charcoal),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(16)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.em(2)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .margin */ .e6$("zero")
    ])
]);
var Styles = {
    heading: heading
};
function OffsetBlocks__BlockHeading(props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: props.children,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
            heading,
            className$1
        ])
    });
}
var make = OffsetBlocks__BlockHeading;
 /* heading Not a pure module */ 


/***/ }),

/***/ 30862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BP": function() { return /* binding */ getExn; },
/* harmony export */   "Wi": function() { return /* binding */ isNone; },
/* harmony export */   "tj": function() { return /* binding */ getWithDefault; }
/* harmony export */ });
/* unused harmony exports some, isSome, isSomeValue, equal, andThen, map, $$default, default, filter, firstSome */
/* harmony import */ var _caml_option_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25400);

function some(x) {
    return Caml_option.some(x);
}
function isSome(param) {
    return param !== undefined;
}
function isSomeValue(eq, v, x) {
    if (x !== undefined) {
        return eq(v, Caml_option.valFromOption(x));
    } else {
        return false;
    }
}
function isNone(param) {
    return param === undefined;
}
function getExn(x) {
    if (x !== undefined) {
        return _caml_option_js__WEBPACK_IMPORTED_MODULE_0__/* .valFromOption */ .xt(x);
    }
    throw new Error("getExn");
}
function equal(eq, a, b) {
    if (a !== undefined) {
        if (b !== undefined) {
            return eq(Caml_option.valFromOption(a), Caml_option.valFromOption(b));
        } else {
            return false;
        }
    } else {
        return b === undefined;
    }
}
function andThen(f, x) {
    if (x !== undefined) {
        return f(Caml_option.valFromOption(x));
    }
}
function map(f, x) {
    if (x !== undefined) {
        return Caml_option.some(f(Caml_option.valFromOption(x)));
    }
}
function getWithDefault(a, x) {
    if (x !== undefined) {
        return _caml_option_js__WEBPACK_IMPORTED_MODULE_0__/* .valFromOption */ .xt(x);
    } else {
        return a;
    }
}
function filter(f, x) {
    if (x === undefined) {
        return;
    }
    var x$1 = Caml_option.valFromOption(x);
    if (f(x$1)) {
        return Caml_option.some(x$1);
    }
}
function firstSome(a, b) {
    if (a !== undefined) {
        return a;
    } else if (b !== undefined) {
        return b;
    } else {
        return;
    }
}
var $$default = (/* unused pure expression or super */ null && (getWithDefault));
 /* No side effect */ 


/***/ })

}]);